import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams, Page } from '@mctic/ng-core';
import { TipoApropriacao } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class TipoApropriacaoService {

  private readonly service = '/sepin-backend/rest/tipos-apropriacao/query';

  constructor(private readonly http: McticHttpClient) {
  }

  obterTodos() {
    return this.http.get<Page<TipoApropriacao>>(this.service);
  }

  obterPorTipoDispendioAndDispendioProprio(idTipoDispendio, dispendioProprio) {
    const queryParams = new McticHttpParams()
      .set('idTipoDispendio', idTipoDispendio)
      .set('dispendioProprio', dispendioProprio);
    return this.http.get<Page<TipoApropriacao>>(this.service, {params: queryParams.toHttpParams()});
  }

}
